import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const getVisitsReportAPI = async (data) => {

    let modifiedData = {
        ...data, visitEnd: data.visitEnd === null ? '' : data.visitEnd,
        visitStart: data.visitStart === null ? '' : data.visitStart
    }
    return await axios.post(`/api/v1/excel-report`, modifiedData)
        .then(function (response) {
            if (response.data) {
                return { success: true, 'visitReport': response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const unlockVisitAPI = async (reportId) => {
    return await axios.get(`/api/v1/unlock-visit`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, response: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}

export const searchVisitReportAPI = async (payload) => {
    return await axios.get(`/api/v1/search-visit-report`, {
        params: {
            risId: payload.risId,
            visitNo: payload.visitNo
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}

export const updateVisitRadiologistAPI = async (payload) => {
    return await axios.get(`/api/v1/admin/update-visit-radiologist`, {
        params: {
            ...payload
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}

export const fetchWorklistVisitsAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };

    return await axios.post(`/api/v1/worklist-visits`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchMipRadiologistUsersAPI = async (data) => {
    const { mipId, risId } = data;

    return await axios.get(`/api/v1/mip-radiologist-users`, {
        params: {
            mipId: mipId,
            risId: risId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const updateWorklistVisitRadiologistAPI = async (payload) => {
    return await axios.post(`/api/v1/update-worklist-visit-radiologist`, payload)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const downloadVisitStatusReportAPI = (groupId) => {
    return axios.get(`/api/v1/download-visit-status-report`, {
        params: {
            groupId
        },
        responseType: "blob",
    }).then(function (response) {
        if (response.data) {
            let [, filename] = response.headers['content-disposition'].split('filename=');
            filename = filename.replaceAll("\"", '');
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            link.click();
            return { success: true };
        } else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false, error: error };
    })
}

export const resetVisitReportAPI = (payload) => {
    return axios.get(`/api/v1/reset-study`, {
        params: {
            ...payload
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchAllReportVersions = async (data) => {
    const { risId, orderNo } = data;

    return await axios.get(`/api/v1/report-versions`, {
        params: {
            risId: risId,
            orderNo: orderNo
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const assignVisitRadiologistAPI = async (payload) => {
    let data = {
        "reportIds": [...payload.reportIds],
        "userId": payload.userId
    }
    return await axios.post(`/api/v1/assign-visit-radiologist`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const unassignVisitRadiologistAPI = async (reportId) => {

    return await axios.get(`/api/v1/unassign-visit-radiologist`, {
        params: {
            'reportId': reportId
        }
    })
        .then(function (response) {

            if (response.status == 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const launchAdvapacsAPI = async (payload) => {
    let data = {
        "viewer": payload.viewer,
        "patientId": payload.patientId,
        "accessionNumber": payload.accessionNumber,
        "username": payload.username,
    }
    return await axios.post(`/api/v1/launch-advapacs`, data)
        .then(function (response) {
            if (response) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}


export const saveTechnicianFindingsAsPDF = async (visitNo, text) => {
    // Convert plain text to inline HTML
    const escapeHtml = (str) =>
        str.replace(/&/g, '&amp;')
           .replace(/</g, '&lt;')
           .replace(/>/g, '&gt;')
           .replace(/"/g, '&quot;')
           .replace(/'/g, '&#039;');

    // Enhanced function to detect and convert tables
    const convertTextToHtml = (text) => {
        const lines = text.split(/\r?\n/);
        let htmlContent = '';
        let currentTable = [];
        let inTable = false;

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const trimmedLine = line.trim();
            
            // Skip separator lines (like ===== or -----)
            const isSeparatorLine = /^[=\-_]{3,}$/.test(trimmedLine);
            
            if (isSeparatorLine) {
                continue; // Skip separator lines entirely
            }
            
            // Detect table-like content
            const isTableRow = (
                trimmedLine.includes('\t') || 
                trimmedLine.includes('|') || 
                (
                    /\s{2,}/.test(trimmedLine) && 
                    trimmedLine.split(/\s{2,}/).length > 1 &&
                    trimmedLine.length > 0
                )
            );
            
            // Also detect if this looks like a header row followed by data
            const nextLine = i + 1 < lines.length ? lines[i + 1].trim() : '';
            const isLikelyTableStart = isTableRow && 
                (nextLine.includes('=') || nextLine.includes('-') || 
                 (i + 1 < lines.length && /\s{2,}/.test(lines[i + 1])));
            
            if ((isTableRow || isLikelyTableStart) && trimmedLine.length > 0) {
                if (!inTable) {
                    // Start new table
                    inTable = true;
                    currentTable = [];
                }
                currentTable.push(trimmedLine);
            } else {
                if (inTable && currentTable.length > 0) {
                    // End current table and convert to HTML
                    htmlContent += convertToHtmlTable(currentTable);
                    currentTable = [];
                    inTable = false;
                }
                
                // Regular line - convert to paragraph or line break
                if (trimmedLine.length > 0) {
                    htmlContent += `<p style="margin: 5px 0;">${escapeHtml(trimmedLine)}</p>`;
                } else {
                    htmlContent += '<br/>';
                }
            }
        }
        
        // Handle remaining table if text ends with table
        if (inTable && currentTable.length > 0) {
            htmlContent += convertToHtmlTable(currentTable);
        }
        
        return htmlContent;
    };

    // Convert detected table rows to HTML table
    const convertToHtmlTable = (tableRows) => {
        if (tableRows.length === 0) return '';
        
        let tableHtml = '<table style="border-collapse: collapse; width: 100%; margin: 10px 0; border: 1px solid #ddd;">';
        
        // First, try to determine column positions from the first few rows
        const columnPositions = detectColumnPositions(tableRows);
        
        tableRows.forEach((row, index) => {
            let cells;
            
            // Parse row based on delimiter
            if (row.includes('\t')) {
                cells = row.split('\t');
            } else if (row.includes('|')) {
                cells = row.split('|').map(cell => cell.trim());
            } else if (columnPositions.length > 0) {
                // Use detected column positions for better parsing
                cells = parseRowByPositions(row, columnPositions);
            } else {
                // Fallback to space-based splitting
                cells = row.split(/\s{2,}/);
            }
            
            // Filter out empty cells
            cells = cells.filter(cell => cell.trim().length > 0);
            
            if (cells.length > 0) {
                tableHtml += '<tr>';
                cells.forEach(cell => {
                    const cellContent = escapeHtml(cell.trim());
                    // Use th for first row if it looks like headers
                    const isHeader = index === 0 && isLikelyHeader(tableRows);
                    const tag = isHeader ? 'th' : 'td';
                    const style = isHeader ? 
                        'style="background-color: #f0f0f0; font-weight: bold; padding: 8px; border: 1px solid #ddd;"' : 
                        'style="padding: 8px; border: 1px solid #ddd;"';
                    tableHtml += `<${tag} ${style}>${cellContent}</${tag}>`;
                });
                tableHtml += '</tr>';
            }
        });
        
        tableHtml += '</table>';
        return tableHtml;
    };

    const detectColumnPositions = (rows) => {
        if (rows.length === 0) return [];
        
        // Look for consistent patterns across rows
        const positions = [];
        const sampleRows = rows.slice(0, Math.min(3, rows.length));
        
        // Find positions where all rows have spaces (column boundaries)
        for (let i = 0; i < 200; i++) { // Reasonable line length limit
            let isColumnBoundary = true;
            for (const row of sampleRows) {
                if (i < row.length && row[i] !== ' ') {
                    isColumnBoundary = false;
                    break;
                }
            }
            if (isColumnBoundary && i > 0) {
                positions.push(i);
            }
        }
        
        return positions;
    };

    // Parse row using detected column positions
    const parseRowByPositions = (row, positions) => {
        const cells = [];
        let start = 0;
        
        for (const pos of positions) {
            if (start < row.length) {
                const cell = row.substring(start, pos).trim();
                if (cell.length > 0) {
                    cells.push(cell);
                }
                start = pos + 1;
            }
        }
        
        // Add remaining text as last cell
        if (start < row.length) {
            const cell = row.substring(start).trim();
            if (cell.length > 0) {
                cells.push(cell);
            }
        }
        
        // Fallback to space splitting if position parsing didn't work well
        if (cells.length <= 1 && /\s{2,}/.test(row)) {
            return row.split(/\s{2,}/);
        }
        
        return cells;
    };

    // Determine if first row looks like headers
    const isLikelyHeader = (rows) => {
        if (rows.length < 2) return false;
        const firstRow = rows[0];
        const secondRow = rows[1];
        
        // Check if first row has more alpha characters relative to numbers
        const alphaCount = (firstRow.match(/[a-zA-Z]/g) || []).length;
        const numCount = (firstRow.match(/[0-9]/g) || []).length;
        
        return alphaCount > numCount && firstRow.length > 0;
    };

    const htmlBody = convertTextToHtml(text);

    // Wrap in minimal HTML document - use inline styles for better PDF compatibility
    const html = `<html><body>${htmlBody}</body></html>`;

    // Minify: remove unnecessary whitespace between tags
    const inlineHtml = html
        .replace(/>\s+</g, '><')
        .trim();

    return await axios.post(`/api/v1/save-pdf-for-visit`, {
        'orderNo': visitNo,
        'text': inlineHtml
    })
        .then(function (response) {
            if (response.status == 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const uploadVisitDocumentForPacs = async (visitNo, document, description) => {
    const formData = new FormData();
    formData.append('visitNo', visitNo);
    formData.append('document', document);
    formData.append('description', description);

    return await axios.post(`/api/v1/upload-visit-document-for-pacs`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(function (response) {

            if (response.status == 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchStudyInstanceUID = async (data) => {
    const { accessionNumber, patientId } = data;

    return await axios.get(`/api/v1/study-instance`, {
        params: {
            accessionNumber,patientId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const generateTechnicianWorksheetAPI = async (reportId) => {
    return await axios.get(`api/v1/generate-technician-worksheet`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return { success: true};
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}
